module.exports = __webpack_public_path__ + "img/draw_mainbox_bg.4d6f9b3c.png";